import { Fragment, useEffect, useState } from 'react';
import { translate } from 'react-switch-lang';
import { Alert, Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { EditButtonIcon } from 'src/component/Buttons/EditButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../../security/hooks/axiosProvider';
import styles from '../../../../styles/style-setting.module.scss';

const EditCountry = (props) => {
  const httpClient = useHttpClient(true);
  const [UpdateModal, setUpdateModal] = useState(false);
  const [countryData, setCountryData] = useState({});
  const [OpenAlert, setOpenAlert] = useState(false);
  const [OpenDangerAlert, setOpenDangerAlert] = useState(false);
  const UpdateModalToggle = () => resetForm();
  const Toggle = () => setOpenAlert(!OpenAlert);
  const DangerAlertToggle = () => setOpenDangerAlert(!OpenDangerAlert);
  const [, setCountryValue] = useState('');
  const [spinner, setSpinner] = useState(false);

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    let item = { ...countryData };
    item[name] = value;
    setCountryData(item);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (countryData['name'] === '') {
        setOpenDangerAlert(true);
        const timer = setTimeout(() => {
          setOpenDangerAlert(false);
        }, 1500);
        countryData['name'] = props.country['name'];
        return () => clearTimeout(timer);
      } else {
        setSpinner(true);
        const response = httpClient.current?.put(`/api/country/update`, countryData);
        if ((await response).status === 200) {
          setSpinner(false);
          props.countries();
          setUpdateModal(!UpdateModal);
        }
      }
    } catch (error) {
      SweetAlert.fire({
        icon: 'error',
        title: 'Ouuups ...',
        text: props.t('err'),
      });
    }
  };

  const resetForm = () => {
    countryData['name'] = props.country['name'];
    setUpdateModal(!UpdateModal);
  };

  useEffect(() => {
    setCountryData(props.country);
  }, [props.country]);

  return (
    <>
      <EditButtonIcon
        title={props.t('update_country')}
        onClick={UpdateModalToggle}
        className={`fa fa-pencil ${styles['action']}`}
      />
      <Modal isOpen={UpdateModal} toggle={UpdateModalToggle} centered>
        <ModalHeader toggle={UpdateModalToggle}>{props.t('update_country')}</ModalHeader>
        <ModalBody>
          <Fragment>
            <Alert className="alert-dismissible" color="success dark" isOpen={OpenAlert} target="Alert">
              <strong>{props.t('great')}</strong>
              <Button className="close" color="default" id="Alert" onClick={Toggle}>
                <span>×</span>
              </Button>
            </Alert>
            <Alert className="alert-dismissible" color="danger dark" isOpen={OpenDangerAlert} target="Alert-2">
              <strong>{props.t('fill_out')}</strong>
              <Button className="close" color="default" id="Alert-2" onClick={DangerAlertToggle}>
                <span>×</span>
              </Button>
            </Alert>
            {spinner === true ? (
              <div className="loader-box">
                <div className="loader-3"></div>
              </div>
            ) : (
              <form className="needs-validation" noValidate onChange={handleChange} onSubmit={handleSubmit}>
                <FormGroup className="form-row">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    id="name"
                    value={countryData['name']}
                    onChange={(event) => setCountryValue(event.target.value)}
                    placeholder={props.t('placeholder_country_name')}
                  />
                </FormGroup>

                <Button outline color="success" className="float-right" type="submit">
                  {props.t('update')}
                </Button>
                <Button className={styles['btn-cancel']} onClick={UpdateModalToggle}>
                  {props.t('cancel')}
                </Button>
              </form>
            )}
          </Fragment>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(EditCountry);
